export const gppApiConsts = {
    API_NAME: "guide-primer-plasmid-api",
    DATABASE_NAME: "gpp",
    tableMetadata: {
        path: {
            COLUMNS_ENUMS: "/table-metadata/columns-enums",
        }
    },
    plasmid: {
        path: {
            NEXT_ID: "/plasmid/next-id",
            GENE_A_GENE_B: "/plasmid/gene-a-gene-b"
        },
    },
    tableData: {
        path: {
            TABLE_DATA: "/table-data",
        }
    },
}